export const globalConst = {
   devURL: 'http://localhost:4200',
   prodURL: 'https://torchbi.com',
   stagingURL: 'https://staging.torchbi.com'
};
